import { gql } from "@apollo/client";

import { GRAPHQL_METHODS } from "../../utils/constants";
import { dateToISO } from "../../utils/dates";
import { networkGraphqlRequest } from "../../utils/networkUtils";

const SAVE_DEMAND = gql`
  mutation submitDemand($cmd: SaveDemandCmd!) {
    saveDemand(cmd: $cmd) {
      caseNumber
    }
  }
`;

function requestData(client, complainantId, complainantInfo, urlFiles) {
  const params = {
    cmd: {
      demandType: complainantInfo.checkedQueja ? "COMPLAINT" : "CLAIM",
      business: complainantInfo.business,
      date: dateToISO(complainantInfo.date),
      area: complainantInfo.area,
      process: complainantInfo.process,
      document: complainantInfo.document,
      documentNumber: complainantInfo.documentNumber,
      country: complainantInfo.country,
      departament: complainantInfo.department,
      reason: complainantInfo.reason,
      currency: complainantInfo.currency,
      amount: parseFloat(complainantInfo.amount),
      detail: complainantInfo.caseDetail,
      order: complainantInfo.demand,
      files: urlFiles,
      claimant: {
        fullName: complainantId.name,
        documentType: complainantId.documentType,
        documentNumber: complainantId.documentId,
        phone: parseInt(complainantId.phoneNumber),
        cellPhone: parseInt(complainantId.mobileNumber),
        email: complainantId.mail,
        position: complainantId.role,
      },
    },
  };
  return networkGraphqlRequest(
    GRAPHQL_METHODS.MUTATION,
    client,
    SAVE_DEMAND,
    params
  );
}

export default requestData;
